/**
 * Use it like this to toggle `.loader` class on element when `isLoading` changes:
 *    `<div v-loading="isLoading">`
 *    (... will become `<div class="loader">`)
 *
 * Add a `button` directive-modifier to also toggle the `.loader--small` class,
 * and the `disabled` attribute on the element:
 *    `<button type="button" v-loading.button="isLoading">`
 *    (... will become `<button type="button" class="loader loader--small" disabled>`)
 *
 * Add a `dark` directive-modifier to also toggle the `.loader--alternate` class:
 *    `<div v-loading.dark="isLoading">`
 *    (... will become `<div class="loader loader--alternate">`)
 *
 * Add a `cloak` directive-modifier to also toggle the `.loader--cloak` class:
 *    `<div v-loading.cloak="isLoading">`
 *    (... will become `<div class="loader loader--cloak">`)
 */

const update = (el, binding) => {
	const isLoading = binding.value;
	const modifiers = binding.modifiers;

	el.classList[isLoading ? 'add' : 'remove']('loader');

	if (modifiers) {
		if (modifiers.button) {
			el.classList[isLoading ? 'add' : 'remove']('loader--small');
			isLoading ? el.setAttribute('disabled', 'disabled') : el.removeAttribute('disabled');
		}

		if (modifiers.dark) {
			el.classList[isLoading ? 'add' : 'remove']('loader--alternate');
		}

		if (modifiers.cloak) {
			el.classList[isLoading ? 'add' : 'remove']('loader--cloak');
		}
	}
};

export default {
	update,
	bind: update
};



// WEBPACK FOOTER //
// ./app/directives/loading.js